import type { STATE_SHORT } from './state'

/**
 * The condition of the trade in vehicle
 */
export enum TRADE_IN_CONDITION {
  Poor,
  Fair,
  Average,
  Good,
  Excellent,
}

/**
 * The query object for the dash get valuation
 */
export interface DashGetValuationQuery {
  registration: string
  state: STATE_SHORT
}

export interface TradeInValuationVehicle {
  make: string
  model: string
  year: number
}

export interface TradeInValuation {
  valueLow: number
  valueHigh: number
  vehicle: TradeInValuationVehicle
}

/**
 * The response object for the dash get valuation
 */
export interface DashGetValuationResponse extends TradeInValuation {}

/**
 * The options for trading a vehicle in.
 */
export type TradingVehicleInOptions = 'YES' | 'NO' | 'LATER'
